import { SeriesFilterState } from './store/series.types';

export const seriesFilterHash = (options: SeriesFilterState['series']): string =>
  Object.keys(options ?? {})
    .sort()
    .filter((seriesValue) => options[seriesValue])
    .join('_');
